import { lazy, Suspense } from 'react';

// Lazy load the PopupModal component
const PopupModal = lazy(() => import('./PopupModal'));

// No visible skeleton needed since modal appears conditionally
// and usually after user interaction or page load
function PopupModalSkeleton() {
    return null;
}

export default function LazyPopupModal() {
    return (
        <Suspense fallback={<PopupModalSkeleton />}>
            <PopupModal />
        </Suspense>
    );
}
